




























































import {
  defineComponent,
  reactive,
  SetupContext,
  onMounted
} from "@vue/composition-api";
import {
  CollectibleFormItem,
  loadCollectibleItems,
  saveCollectibleItems,
  StartHourList
} from "@/models/Collectibles";
import { copyData } from "@/utils";
import { v4 as uuidv4 } from "uuid";

type TableOption = {
  data: CollectibleFormItem[];
  striped: boolean;
};

export default defineComponent({
  setup(props: never, context: SetupContext) {
    let originalData: CollectibleFormItem[] = [];
    const option = reactive<TableOption>({
      data: copyData(originalData),
      striped: true
    });

    onMounted(async () => {
      originalData = await loadCollectibleItems();
      option.data = copyData(originalData);
    });

    const save = async () => {
      const result = await saveCollectibleItems(option.data);
      if (!result) {
        context.root.$buefy.dialog.alert("データが不正です");
        return;
      }
      originalData = copyData(option.data);
      context.root.$buefy.dialog.alert("保存しました");
    };
    const add = () => {
      const item: CollectibleFormItem = { id: uuidv4() };
      option.data.push(item);
    };
    const reset = () => {
      option.data = copyData(originalData);
    };
    const remove = (id: string) => {
      const index = option.data.findIndex(item => item.id == id);
      if (index == -1) return;
      option.data.splice(index, 1);
    };
    return {
      option,
      StartHourList,
      save,
      add,
      reset,
      remove
    };
  }
});
